export enum QueryOptionsApi {
    Internal,
    Rest,
    Addons,
    Market,
    Workflows,
    Open,
}
